import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { HTTP_SERVICE } from './core/services/http.interface';
import { HttpService } from './core/services/http.service';
import { USER_AUTHENTICATION_SERVICE } from './core/services/user-auth.interface';
import { UserAuthService } from './core/services/user-auth.service';

export const ProviderList: Provider[] = [
  { provide: HTTP_SERVICE, useClass: HttpService },
  { provide: USER_AUTHENTICATION_SERVICE, useClass: UserAuthService },
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
];
